export default __webpack_public_path__ + "static/media/element_spec_21.b2691c7e.jpg";